module.exports = "/_next/static/media/icon-paypal.d167dbd7.svg";